import React from "react";
import { useParams } from "react-router-dom";
import { Devices, PairScreen, Schedules, ScreenEdit } from "./components";
import { ScreenInterface, ApiHelper, UserHelper, ToastHelper } from "../helpers"
import { v4 } from 'uuid';

interface Props {
  refreshSidebar: () => void,
}


export const ScreenPage = (props: Props) => {
  const { id } = useParams<{ id: string }>();

  const [screen, setScreen] = React.useState<ScreenInterface>(null);
  const [showPair, setShowPair] = React.useState(false);

  const init = () => {
    setShowPair(false);
    if (id === "0") createScreen();
    else ApiHelper.get<ScreenInterface>("/screens/" + id)
      .then((data) => { setScreen(data); })
      .catch(() => {
        ToastHelper.error("Failed to load screen");
      });
  }

  const createScreen = () => {
    const guid = v4().replaceAll("-", "");
    ApiHelper.get<{ timezone?: string }>("/users/" + UserHelper.user.id)
      .then(u => {
        setScreen({ id: 0, screenMode: "digitalsignage", name: "", timezone: u?.timezone || "America/New_York", guid: guid });
      })
      .catch(() => { /* timezone load failed */ });
  }

  const getRightSide = () => {
    const result: React.ReactElement[] = [];
    if (screen) {
      if (showPair) result.push(<PairScreen key="pairScreen" screen={screen} onClose={() => setShowPair(false)} />)
      if ((screen.screenMode === "digitalsignage" || screen.screenMode === "both") && screen.id > 0) result.push(<Schedules key="schedules" screen={screen}  />);
    }
    return result;
  }


  React.useEffect(init, [id])

  return (
    <div className="page-container">
      <div className="page-header">
        <h1><i className="fas fa-tv"></i> Screens</h1>
      </div>
      <div className="edit-layout">
        <div className="edit-column">
          <ScreenEdit screen={screen} refreshSidebar={props.refreshSidebar} onUpdate={setScreen} showPair={() => { setShowPair(true); }} />
          <Devices screen={screen} />
        </div>
        <div className="edit-column">
          {getRightSide()}
        </div>
      </div>
    </div>
  )


};